import { Grid, CircularProgress, Box } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { getAllTeamsInWorkspace, getMyTeams, ITemplateDTO } from 'wisestep-api';
import {
  EmptyTeamsAndUsersIcon,
  ScrollableTabs,
  WsButton,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsColors,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../components/noDataFoundCard/NoDataFoundCard';
import { extractTeamNameAndId } from '../../../../features/jobs/helper';
import { IAssignState, INameAndId, StyledFooter } from '../../type/type';

import TemplateTeamList from './TemplateTeamList';

export interface AssignProps {
  onSkip?: () => void;
  variant: 'new' | 'edit' | 'clone';
  formData: ITemplateDTO;
  teamsIDs: (templateData: ITemplateDTO) => void;
}
const AssignTemplate: FC<AssignProps> = ({ onSkip, variant, formData, teamsIDs }) => {
  const [tabPanelPage, setTabPanelPage] = useState(0);
  const [assignedTeams, setAssignedTeams] = useState<INameAndId[]>();
  const [teams, setTeams] = useState<INameAndId[]>();
  const [tempalateData, setTempalateData] = useState<ITemplateDTO>(formData);
  const [loader, setLoader] = useState(false);
  const assignHandler = (tempData: ITemplateDTO) => {
    setTempalateData(tempData);
    setTabPanelPage(1);
    teamsIDs(tempData);
  };

  const skipHandler = () => {
    if (onSkip !== undefined) {
      onSkip();
    }
  };
  const methods = useForm();
  useEffect(() => {
    (async function () {
      const assignState: IAssignState = {};
      setLoader(true);
      const teamsOwn = await getMyTeams();
      const teamBelongsto = await getAllTeamsInWorkspace();
      assignState.currentUserTeams = [...(teamsOwn?.data ?? []), ...(teamBelongsto?.data ?? [])];
      assignState.currentUserTeamsArray = extractTeamNameAndId(assignState?.currentUserTeams ?? []);

      const assignedteamData: INameAndId[] = [];

      if (assignState?.currentUserTeamsArray && tempalateData?.teamIds) {
        if (assignState.currentUserTeamsArray?.length > 0) {
          tempalateData?.teamIds?.forEach((obj) =>
            assignState.currentUserTeamsArray?.some((value) => {
              if (obj === value.id) {
                assignedteamData.push(value);
              }
            })
          );
          setAssignedTeams(assignedteamData);
        }
      }
      if (assignState && tempalateData) {
        const teams: INameAndId[] = assignState.currentUserTeamsArray;
        const unAssignedTeams = teams.filter(
          (team) => !tempalateData?.teamIds?.find((id) => id === team.id)
        );
        setTeams(unAssignedTeams);
      }
      setLoader(false);
    })();
  }, [tempalateData, tempalateData?.teamIds, variant]);

  return (
    <>
      {teams && assignedTeams && !loader ? (
        <>
          <Grid mt={2}>
            <ScrollableTabs
              scrollList={[
                { tabName: 'Choose Teams' },
                {
                  tabName: 'Assigned',
                  tabCount: tempalateData.teamIds?.length ?? 0,
                },
              ]}
              getTabIndex={setTabPanelPage}
              defaultValue={tabPanelPage}
            />
          </Grid>
          <FormProvider {...methods}>
            <Grid container p={2} mb={5}>
              {teams && assignedTeams && (
                <TemplateTeamList
                  teamData={tabPanelPage == 0 ? teams : assignedTeams}
                  onAssign={assignHandler}
                  skipHandler={skipHandler}
                  formData={tempalateData}
                  tabPanelPage={tabPanelPage}
                />
              )}
            </Grid>
          </FormProvider>
        </>
      ) : loader ? (
        <Grid container item justifyContent="center" py={1}>
          <Box textAlign="center" pt={4}>
            <CircularProgress disableShrink sx={{ color: WsColors.TheBlues500 }} />
          </Box>
        </Grid>
      ) : (
        <>
          <Grid container sx={{ position: 'absolute', width: '100%' }} mt={2} ml={2}>
            <NoDataFoundCard
              text={'Oops! No teams found.'}
              icon={<EmptyTeamsAndUsersIcon />}
              subElement={
                <Grid container p={4}>
                  <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
                    Tip: You can easily share your template with other teams once they have been
                    created
                  </WsTypography>
                </Grid>
              }
            />
          </Grid>
          <StyledFooter>
            <Grid container item justifyContent="center" py={1}>
              <WsButton onClick={skipHandler} variant="contained" size="large">
                Proceed to Save
              </WsButton>
            </Grid>
          </StyledFooter>
        </>
      )}
    </>
  );
};
export default AssignTemplate;
